export default __webpack_public_path__ + "static/media/background1.60f64a97.png";